export const convertCurrencyStringToFloat = (currencyString?: string) => parseFloat((currencyString && currencyString.replace(/,/g, "")) || "0");

export const getTotalSalary = (annualSalary?: string, partnersSalary?: string) => convertCurrencyStringToFloat(annualSalary)
  + convertCurrencyStringToFloat(partnersSalary);

export const calculateTotalBorrowAmount = (
  annualSalary?: string,
  partnersSalary?: string,
  monthlyOutgoings?: string,
) => {
  const totalAnnualIncome = getTotalSalary(annualSalary, partnersSalary);
  const multiplier = totalAnnualIncome <= 30000 ? 4.5 : 5;

  const annualOutgoings = monthlyOutgoings !== undefined ? 12 * convertCurrencyStringToFloat(monthlyOutgoings) : 0;
  return (totalAnnualIncome - annualOutgoings) * multiplier;
};

export const calculateMonthlyRepaymentAmount = (
  p: number,
  r: number,
  n: number,
) =>
/*
   * p = borrow amount
   * r = monthly interest rate (annual interest rate / 12)
   * n = number of months
   */

  (p * (r * (1 + r) ** n)) / ((1 + r) ** n - 1);
